import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../utils/tw';
import { focusRing, hitArea } from '../../ui/utils/a11y';

interface Props {
  label: string;
  to: string;
  icon: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
  collapsed?: boolean;
  className?: string;
  end?: boolean;
}

const IconLink: React.FC<Props> = ({ label, to, icon, active, onClick, collapsed, className, end }) => {
  return (
    <NavLink
      to={to}
      end={end}
      onClick={onClick}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-3 px-4 py-3 text-sm transition-all duration-200 rounded-lg',
          collapsed ? 'justify-center px-2' : '',
          focusRing,
          hitArea,
          className,
          !className && (active || isActive) && 'bg-primary/10 text-primary font-medium',
          !className && !(active || isActive) && 'text-mutedText hover:bg-hover hover:text-text'
        )
      }
      title={collapsed ? label : undefined}
    >
      <span className="w-5 h-5 flex-shrink-0 opacity-90 group-hover:opacity-100 transition-opacity">{icon}</span>
      {!collapsed && <span className="truncate">{label}</span>}
    </NavLink>
  );
};

export default IconLink;
